import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { ConsultantIntro } from "@/components/site/ConsultantIntro";
import { Solutions } from "@/components/site/Solutions";
import { Operators } from "@/components/site/Operators";
import { Children } from "@/components/site/Children";
import { Family } from "@/components/site/Family";
import { MedSenior } from "@/components/site/MedSenior";
import { Business } from "@/components/site/Business";
import { Manifesto } from "@/components/site/Manifesto";
import { WhatsAppMockup } from "@/components/site/WhatsAppMockup";
import { Testimonials } from "@/components/site/Testimonials";
import { FinalCTA } from "@/components/site/FinalCTA";
import { Footer } from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-cream font-sans antialiased">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <ConsultantIntro />
        <Solutions />
        <Operators />
        <Children />
        <Family />
        <MedSenior />
        <Business />
        <Manifesto />
        <Testimonials />
        <WhatsAppMockup />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
